
const propertyAccess = {
  PUBLIC: 'public',
  PRIVATE: 'private',
}

export function propertyAccessColor(status){
  if (!status || status === propertyAccess.PUBLIC) {
    return '#67C23A'
  }

  if (!status || status === propertyAccess.PRIVATE) {
    return '#E6A23C'
  }
}
export function propertyAccessTagType(status){
  if (!status || status === propertyAccess.PUBLIC) {
    return 'success'
  }
  if (!status || status === propertyAccess.PRIVATE) {
    return 'warning'
  }
}
export default propertyAccess;